import scrollTo from '../common/scrollTo'
import { on } from 'delegated-events'
import { Swiper, Navigation } from 'swiper'

Swiper.use([Navigation])

const state = {
  filterSlider: null,
}
const filterHeading = document.querySelector('.fund-type-filter-heading')

const fn = {
  init: () => {
    on('click', '.fund-type-comparison-toggles button', fn.handleComparisonToggle)

    on('click', '.fund-type-filter', fn.handleFilter)
    on('click', '.fund-type-filters-clear', fn.handleClearFilter)

    fn.setupFilterSlider()

    window.addEventListener('resize', fn.handleNavigationControls)
  },

  handleComparisonToggle: (e) => {
    const target = document.getElementById(e.target.dataset.target)

    if (target) {
      document.querySelectorAll('.fund-type-comparison').forEach((x) => x.classList.add('_hidden'))
      document.querySelectorAll('.fund-type-comparison-toggles button').forEach((x) => x.classList.remove('is-active'))

      target.classList.remove('_hidden')
      e.target.classList.add('is-active')
    }
  },

  handleFilter: (e) => {
    const el = e.target.closest('button')
    const filter = el.dataset.filter
    const filterClass = `has-filter-${filter}`
    const filterName = el.querySelector('span').textContent

    document.querySelectorAll('.fund-type-filter').forEach((x) => x.classList.remove('is-active'))
    el.classList.add('is-active')

    document.querySelectorAll('.fund-type').forEach((x) => x.classList.add('_hidden'))
    document.querySelectorAll(`.fund-type.${filterClass}`).forEach((x) => x.classList.remove('_hidden'))

    filterHeading.querySelector('span').textContent = filterName
    filterHeading.classList.remove('_hidden')

    scrollTo(document.querySelector('.fund-type-list'))
  },

  handleClearFilter: () => {
    document.querySelectorAll('.fund-type-filter').forEach((x) => x.classList.remove('is-active'))

    document.querySelectorAll('.fund-type').forEach((x) => x.classList.remove('_hidden'))

    filterHeading.classList.add('_hidden')
  },

  setupFilterSlider: () => {
    const container = document.querySelector('.fund-type-filters .swiper-container')

    if (!container) {
      return
    }

    const numSlides = container.querySelectorAll('.swiper-slide').length

    const opts = {
      slidesPerView: 3,
      spaceBetween: 20,
      breakpoints: {
        768: {
          touchRatio: 0,
          slidesPerView: 4,
        },
        1024: {
          touchRatio: 0,
          slidesPerView: 6,
        },
      },
    }

    if (numSlides > 1) {
      opts.navigation = {
        nextEl: container.querySelector('.fund-type-filters-button-next'),
        prevEl: container.querySelector('.fund-type-filters-button-prev'),
      }
    }

    state.filterSlider = new Swiper(container, opts)

    fn.handleNavigationControls()
  },

  handleNavigationControls: () => {
    const controls = document.querySelector('.fund-type-filters-controls')

    if (state.filterSlider && controls) {
      if (state.filterSlider.isBeginning && state.filterSlider.isEnd) {
        controls.classList.add('invisible')
      } else {
        controls.classList.remove('invisible')
      }
    }
  },
}

export default {
  can: () => document.body.classList.contains('pagetype-creatingafundpage'),
  run: fn.init,
}
